import { PlusOutlined } from '@ant-design/icons'
import { Button, Empty, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import {
  getFastLaneDetail,
  getFastLaneList,
  updateResponseWorkStatus,
} from '../../api/aopsFastLane.api'
import FastLaneCard from '../../components/apos/fastLane/FastLaneCard'
import FastLaneModal from '../../components/apos/fastLane/FastLaneModal'
import ResponseModal from '../../components/apos/fastLane/ResponseModal'
import AopsCommonConfirmModal from '../../components/apos/modal/AopsCommonConfirmModal'
import SectionHeader from '../../components/apos/SectionHeader'
import { userState } from '../../store/user'
import './fastLaneBoard.scss'
const ResponseBoard = ({
  onReloadInitData,
  setFastLaneList,
  fastLaneList,
  userId,
  myId,
}) => {
  const [user] = useRecoilState(userState)
  // Response 업무 상세 모달
  const [isModalOpen, setIsModalOpen] = useState(false)
  // Response 업무 리스트
  const [responseList, setResponseList] = useState([])
  // Response 업무 상세
  const [responseDetail, setResponseDetail] = useState(null)
  // 선택된 Response 업무
  const [selectedResponse, setSelectedResponse] = useState(null)
  // 패스트 업무 생성 모달
  const [isFastLaneModalOpen, setIsFastLaneModalOpen] = useState(false)
  // 패스트 업무 생성 확인 모달
  const [openConfirmSwitchCompleteModal, setOpenConfirmSwitchCompleteModal] =
    useState(false)
  // 에러 모달
  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error.response.data.detail[1].description,
    })
  }

  useEffect(() => {
    fetchResponseList()
  }, [])
  const fetchResponseList = async (type = 'RESPONSE_WORK') => {
    try {
      const res = await getFastLaneList(userId, type)
      const data = res?.slice(0, 100) || []
      if (type === 'RESPONSE_WORK') {
        setResponseList(data)
      } else {
        setFastLaneList(data)
      }
    } catch (error) {
      console.log(error)
      setResponseList([])
      openErrorModal(error)
    }
  }

  const sortedData = responseList.sort((a, b) => {
    // 1️⃣ isComplete가 false인 것이 우선
    if (a.isComplete !== b.isComplete) {
      return a.isComplete ? 1 : -1
    }

    // 2️⃣ dueDateTime 최신순 정렬
    return new Date(b.dueDateTime) - new Date(a.dueDateTime)
  })

  const handleSwitchComplete = async (workId, isComplete) => {
    try {
      const res = await updateResponseWorkStatus(workId, {
        isComplete: !isComplete,
      })
      setSelectedResponse(null)
      fetchResponseList()
      onReloadInitData()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  const handleClickDetail = async (workId) => {
    try {
      const res = await getFastLaneDetail(workId)
      // console.log(res)
      setResponseDetail(res)
      setIsModalOpen(true)
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  useEffect(() => {
    if (!isModalOpen) {
      setResponseDetail(null)
    }
  }, [isModalOpen])

  return (
    <>
      <div className="fast-lane-board">
        <SectionHeader
          title="Response 보드"
          subtitle="Response 업무를 빠르게 처리해주세요"
          // buttonText={'Response 업무 생성'}
          // onButtonClick={() => setIsModalOpen(true)}
        />

        <div className={'fast-lane-board-content'}>
          <div className={'content-header'}>
            <Flex gap={8} align="center" justify="space-between">
              <div>
                <p className={'content-header-title'}>업무 현황</p>
                <Flex gap={8} align="center">
                  <Flex gap={4}>
                    <span className={'text-title'}>예정</span>
                    <span className={'text-count'}>
                      {responseList?.filter((item) => !item.isComplete).length}
                    </span>
                  </Flex>
                  <div className={'text-divider'} />
                  <Flex gap={4}>
                    <span className={'text-title'}>완료</span>
                    <span className={'text-count'}>
                      {responseList?.filter((item) => item.isComplete).length}
                    </span>
                  </Flex>
                </Flex>
              </div>
              {userId === myId && (
                <Button
                  type="default"
                  onClick={() => setIsModalOpen(true)}
                  className={'register-fast-button'}
                >
                  Response 업무 생성
                  <PlusOutlined />
                </Button>
              )}
            </Flex>
          </div>
          <div className={'fast-lane-card-list'}>
            {sortedData.map((item) => (
              <FastLaneCard
                key={item.workId}
                {...item}
                onClickSwitchComplete={() => {
                  if (item.isComplete) {
                    handleSwitchComplete(item.workId, item.isComplete)
                    return
                  }
                  setSelectedResponse(item)
                  setOpenConfirmSwitchCompleteModal(true)
                }}
                onClickDetail={() => handleClickDetail(item.workId)}
                // openErrorModal={openErrorModal}
              />
            ))}
            {responseList.length === 0 && (
              <div className={'empty-list no-shadow'}>
                <Empty description="Response 업무가 없습니다." />
              </div>
            )}
          </div>
        </div>
      </div>
      <ResponseModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        responseDetail={responseDetail}
        title={responseDetail ? 'Response 업무 상세' : 'Response 업무 생성하기'}
        fetchResponseList={fetchResponseList}
        onReloadInitData={onReloadInitData}
      />

      <AopsCommonConfirmModal
        open={openConfirmSwitchCompleteModal}
        onClose={() => setOpenConfirmSwitchCompleteModal(false)}
        title="패스트 업무를 등록할까요?"
        description={`리스폰스 업무가 완료되었습니다.\n지금 바로 처리해야 할 후속 업무가 있다면 패스트 업무로 등록해 주세요.`}
        onCancel={() => {
          setOpenConfirmSwitchCompleteModal(false)
          handleSwitchComplete(
            selectedResponse?.workId,
            selectedResponse?.isComplete,
          )
        }}
        onConfirm={() => {
          setIsModalOpen(false)
          setIsFastLaneModalOpen(true)
          setOpenConfirmSwitchCompleteModal(false)
          handleSwitchComplete(
            selectedResponse?.workId,
            selectedResponse?.isComplete,
          )
        }}
      />

      <FastLaneModal
        open={isFastLaneModalOpen}
        onClose={() => setIsFastLaneModalOpen(false)}
        title={`패스트 업무 생성하기`}
        fastLaneDetail={null}
        fetchFastLaneList={() => fetchResponseList('FASTLANE_WORK')}
        onReloadInitData={onReloadInitData}
      />
    </>
  )
}

export default ResponseBoard
